import { render, staticRenderFns } from "./VError.vue?vue&type=template&id=cb14ea52&"
import script from "./VError.vue?vue&type=script&lang=js&"
export * from "./VError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports